import { SimplePage } from "./_shared"; export default function Page(){return <SimplePage title="Help Center" />;}
